<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3">
        {{ $t("expiring gym members") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("expire date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- <pre>{{ members }}</pre> -->
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("membership end date") }}</th>
            <!-- <th>{{ $t("actions") }}</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in members" :key="member.id">
            <td>{{ member.name }}</td>
            <td>{{ format_date(member.membership_expire_date) }}</td>
            <!-- <td>
              <button
                class="button is-small is-danger"
                @click="deleteMember(member.id)"
              >
                {{ $t("delete") }}
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "ExpiringMemberReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      members: [],
      meta: {
        start_date: "",
        end_date: "",
      },
    };
  },
  computed: {},
  methods: {
    format_date,
    query() {
      let v = this;
      get("/apis/gym_member/expiring", v.meta)
        .then((r) => {
          v.members = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {},
};
</script>

<style>
/* Add Bulma styles here */
</style>
